// SupplierPage.js

import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import Footer from "common/Footer";
import SupplierList from "common/Suppliers/SupplierList";
import ImportSuppliersButton from "common/Suppliers/ImportSuppliersButton";
import { Box, Fade, IconButton, Tooltip } from "@mui/material";
import { Add as AddIcon, Refresh as RefreshIcon } from "@mui/icons-material";
import { useSnackbar } from "context/SnackbarContext";
import { useLanguage } from "context/LanguageContext";

const SupplierPage = () => {
  const [suppliersUpdated, setSuppliersUpdated] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const showSnackbar = useSnackbar();
  const { t } = useLanguage();

  const handleImportSuccess = () => {
    setSuppliersUpdated((prev) => !prev);
    showSnackbar(t("suppliersImportedSuccessfully"), "success");
  };

  const handleRefresh = () => {
    setIsRefreshing(true);
    setSuppliersUpdated((prev) => !prev);
    setTimeout(() => {
      setIsRefreshing(false);
      showSnackbar(t("supplierListRefreshed"), "success");
    }, 500);
  };

  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  {t("supplierManagement")}
                </MDTypography>
                <Box display="flex" gap={1}>
                  <Tooltip title={t("refreshList")}>
                    <IconButton
                      color="inherit"
                      onClick={handleRefresh}
                      sx={{
                        transform: isRefreshing ? "rotate(180deg)" : "none",
                        transition: "transform 0.5s ease-in-out",
                      }}
                    >
                      <RefreshIcon />
                    </IconButton>
                  </Tooltip>
                  <ImportSuppliersButton onImportSuccess={handleImportSuccess}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <AddIcon />
                      <MDTypography variant="button" color="white">
                        {t("importSuppliers")}
                      </MDTypography>
                    </Box>
                  </ImportSuppliersButton>
                </Box>
              </MDBox>

              <Fade in={!isRefreshing} timeout={500}>
                <Box>
                  <SupplierList suppliersUpdated={suppliersUpdated} />
                </Box>
              </Fade>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default SupplierPage;
